module.exports = require("date-fns");


//////////////////
// WEBPACK FOOTER
// external "date-fns"
// module id = 23
// module chunks = 0